import { render, staticRenderFns } from "./live.vue?vue&type=template&id=7166ce04&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"
import style0 from "./live.vue?vue&type=style&index=0&id=7166ce04&prod&lang=scss&scoped=true"
import style1 from "./live.vue?vue&type=style&index=1&id=7166ce04&prod&lang=scss"
import style2 from "./live.vue?vue&type=style&index=2&id=7166ce04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7166ce04",
  null
  
)

export default component.exports